export default function PHP_EchoPrint() {
  return (
    <div>
      <h1>PHP_EchoPrint</h1>
    </div>
  );
}
